<div class="panel-group flex flex-col gap-2">
  @for (item of items(); track item.id) {
    <pfx-detailed-panel
      [data]="item"
      [clickable]="clickable()"
      [class.selected]="selectedPanelId() && selectedPanelId() === item.id"
      [class.cursor-pointer]="clickable()"
      (panelClicked)="handleOnPanelClicked(item)"
    >
      @if (getPanelTemplate(PanelTemplateType.ICONS); as iconsTemplate) {
        <ng-template [pfxTemplate]="PanelTemplateType.ICONS">
          <ng-container *ngTemplateOutlet="iconsTemplate; context: { $implicit: item.meta }"></ng-container>
        </ng-template>
      }

      @if (item.details) {
        <ng-template [pfxTemplate]="PanelTemplateType.CONTENT">
          <div class="py-1">
            @if (getPanelTemplate(PanelTemplateType.CONTENT); as contentTemplate) {
              <ng-container
                *ngTemplateOutlet="contentTemplate; context: { $implicit: item.details, id: item.id }"
              ></ng-container>
            } @else {
              <p>
                {{ item.details | json }}
              </p>
            }
          </div>
        </ng-template>
      }
    </pfx-detailed-panel>
  }
</div>
